import { makeStyles, Theme } from '@material-ui/core/styles';
import { BrandColors } from '../../constants';

export const PromptBoxStyles = makeStyles((theme: Theme) => ({
  box: {
    opacity: 0.85,
    top: 40,
    padding: '3rem 1.5rem',
    [theme.breakpoints.up('md')]: {
      top: '50px',
      padding: '1.5rem',
    },
  },
  button: {
    color: BrandColors.black,
    backgroundColor: BrandColors.white,
    '&:hover': {
      color: BrandColors.white,
      backgroundColor: BrandColors.black,
    },
  },
  title: {
    marginBottom: '1.25rem',
  },
  content: {
    fontWeight: 600,
    marginBottom: '1.25rem',
  },
}));
